import { Link } from 'gatsby'
import React from 'react'
import { Html } from './html'
import { RichContent } from './richContent'

// components

export const Post = ({ link, post }) => (
  <>
    <p>{post.date}</p>

    <p>{link ? <Link to={`/blog${link}`}>{post.title}</Link> : post.title}</p>

    {post.content.contentList.map(item => (
      <div key={item._key}>
        <RichContent richContent={item._rawRichContent} />

        <Html html={item.html} />
      </div>
    ))}
  </>
)
